// Homepage Banner Fade Slider
require("slick-carousel");

$(document).ready(function (evt) {
  slickFadeSlider();
});

function slickFadeSlider() {
  $(".c-homepage-banner__image-area").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    fade: true,
    cssEase: "linear",
    draggable: false,
    arrows: false,
    swipeToSlide: false,
  });
}
